export default "__VITE_ASSET__60b9a5a4__"